import eventBus from '@/events/eventBus';

export default class SizeWatcher {

  constructor(breakpointFunc: () => any) {
    window.addEventListener('resize', () => this.onResize(breakpointFunc()), { passive: true });
    this.onResize(breakpointFunc());
  }

  public onResize(breakpoint) {
    const bp = ['xs', 'sm', 'md', 'lg', 'xl'];
    let name = '?';
    bp.forEach((b) => {
      if (breakpoint[b]) {
        name = b;
      }
    });
    switch (breakpoint.name) {
      case 'xs':
      case 'sm':
        break;
      case 'md':
      case 'lg':
      case 'xl':
      default:
        break;
    }
    eventBus.emit('resize', { name, width: breakpoint.width, height: breakpoint.height });
  }
}
